document.addEventListener("DOMContentLoaded", function () {
    $('.readmore_button').click(function (e){
        e.preventDefault();
        $(this).parent('.readmore').toggleClass('show');
    });
    $('[data-bs-toggle="tooltip"]').tooltip();
    (function(e) {
        const $dropdown = $(".dropdown");
        const $dropdownToggle = $(".dropdown-toggle");
        const $dropdownMenu = $(".dropdown-menu");
        const $tabButton = $("#navbarNav .nav-link");
        const showClass = "show";
        const activeClass = "active";
        $(window).on("load resize", function() {
            if (this.matchMedia("(min-width: 768px)").matches) {
                $dropdown.hover(
                    function() {
                        const $this = $(this);
                        $this.addClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "true");
                        $this.find($dropdownMenu).addClass(showClass);
                    },
                    function() {
                        const $this = $(this);
                        $this.removeClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "false");
                        $this.find($dropdownMenu).removeClass(showClass);
                    }
                );
                $tabButton.hover(
                    function (){
                        const $this = $(this);
                        $this.click();
                    }
                );
            } else {
                $dropdown.off("mouseenter mouseleave");
                $tabButton.off("mouseenter mouseleave");
            }
        });

        $('#toggleMenu').click(() => {
            $('body').toggleClass('openMenu');
        });

    })(jQuery);
});
